import { Component, OnInit } from '@angular/core';
import { NgIf } from "@angular/common";
import { MyProjectsCardComponent } from "../../projects/my-projects-card/my-projects-card.component";
import { CommentProjectCardComponent } from "../../../core/comment/comment-project-card/comment-project-card.component";
import { AuthService } from "../../../_shared/services";
import { getTenantStorage } from "../../../_shared/utils/tenant-context";

@Component({
  selector: 'app-pps',
  standalone: true,
  imports: [
    NgIf,
      MyProjectsCardComponent,
      CommentProjectCardComponent
  ],
  templateUrl: './pps.component.html',
  styleUrl: './pps.component.sass'
})
export class PpsComponent  implements OnInit {
  checker: boolean = false;
  staffId: number = 0;

  constructor(
      public authService: AuthService,) {}

  ngOnInit() {
    this.checker = this.authService.checker;
    this.staffId = parseInt(getTenantStorage('staff_id') ?? '0', 10) || 0;
  }
}
